module.exports = __webpack_public_path__ + "static/media/discount-announcement.78b66751.png";